import ServiceBase from "./ServiceBase"

const resource = "/customers"

export default
	{
		getCustomers()
		{
			return ServiceBase.get(resource)
		},
		getCustomer(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updateCustomer(payload)
		{
			return ServiceBase.put(resource + "/" + payload.id, payload)
		},
		addCustomer(payload)
		{
			return ServiceBase.post(resource, payload)
		},
		exportEmails(payload)
		{
			return ServiceBase.get(resource + "/exportemails/" + payload.customerid + "/" + payload.agreementid)
		},
		exportLowResImages(payload)
		{
			return ServiceBase.get(resource + "/exportlowresimages/" + payload.customerid + "/" + payload.agreementid)
		},
		exportOrdersDetails(payload)
		{
			return ServiceBase.get(resource + "/exportordersdetails/" + payload.customerid + "/" + payload.agreementid)
		},
		exportOrdersDeliveryNotes(payload)
		{
			return ServiceBase.get(resource + "/exportordersdeliverynotes/" + payload.customerid + "/" + payload.agreementid)
		}
	}